// MeloCraft mark — Concept C "Breakout".
// A sliced hex (rotated for velocity) with an eighth-note whose stem
// punches THROUGH the top edge. Motion + rebellion in a single glyph.
// Ember (#FF4500) + inner highlight + black note. Reads crisp from
// favicon (16px) up to hero banner.
export function LogoMark({ size = 40, className = "" }) {
  return (
    <svg
      viewBox="0 0 140 140"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="MeloCraft"
    >
      <g transform="translate(10 10)">
        {/* Sliced hex — the click-me shape */}
        <polygon
          points="60,10 105,35 105,85 60,110 15,85 15,35"
          fill="#FF4500"
          transform="rotate(-6 60 60)"
        />
        {/* Inner highlight facet — the "sliced" catch of light */}
        <polygon
          points="60,10 105,35 60,60 15,35"
          fill="#FF6B00"
          transform="rotate(-6 60 60)"
          opacity="0.55"
        />
        {/* Eighth note — stem breaks OUT the top of the hex */}
        <g transform="rotate(-6 60 60)">
          <rect x="66" y="-4" width="6" height="76" fill="#0A0A0A" />
          <path d="M72 -4 Q94 4 88 24 Q88 10 72 10 Z" fill="#0A0A0A" />
          <polygon points="42,66 72,62 74,80 44,84" fill="#0A0A0A" />
        </g>
      </g>
    </svg>
  );
}

// Full wordmark with the mark + typographic lockup, for large headers/hero.
export function Wordmark({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <LogoMark size={36} />
      <span className="font-display font-black tracking-tighter leading-none text-2xl md:text-3xl">
        Melo<span className="text-[#FF4500]">Craft</span>
      </span>
    </span>
  );
}
